import {GET_ERRORS} from './types';

// RETURN ERRORS
export const returnErrors = (errData, status) => {
    return {
        type: GET_ERRORS,
        payload: {error: errData, status},
    };
};